import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import type {
  LockboxVendor,
  LockboxVerificationStatus
} from "api/landlord/lockboxes/types";
import {
  NOT_APPLICABLE_LABEL,
  VERIFICATION_STATUS_LABELS,
  isNoVendor
} from "../constants";

const STATUS_VARIANT: Record<LockboxVerificationStatus, BadgeVariant> = {
  verified: BadgeVariant.SUCCESS,
  failed: BadgeVariant.ERROR,
  not_verified: BadgeVariant.BASE
};

interface VerificationStatusPillProps {
  status: LockboxVerificationStatus;
  vendor?: LockboxVendor | null;
}

export const VerificationStatusPill = ({
  status,
  vendor
}: VerificationStatusPillProps) => {
  if (isNoVendor(vendor ?? null))
    return (
      <Badge variant={BadgeVariant.BASE} size={BadgeSize.SM}>
        {NOT_APPLICABLE_LABEL}
      </Badge>
    );

  return (
    <Badge variant={STATUS_VARIANT[status]} size={BadgeSize.SM}>
      {VERIFICATION_STATUS_LABELS[status]}
    </Badge>
  );
};
